'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));
var styled = _interopDefault(require('styled-components'));
var reactSpring = require('react-spring');

var LEFT = 'left';
var RIGHT = 'right';
var List = function List(_ref) {
  var slideDirection = _ref.slideDirection,
    unidirectional = _ref.unidirectional,
    Container = _ref.containerComponent,
    transitionComponent = _ref.transitionComponent,
    _ref$item = _ref.item,
    wrapper = _ref$item.wrapper,
    divider = _ref$item.divider,
    children = _ref.children;
  var items = (Array.isArray(children) ? children : [children]).reduce(function (acc, child, index, array) {
    acc.push(wrapper ? wrapper(index, array, child) : child);
    if (divider) acc.push(divider(index, array));
    return acc;
  }, []);
  var enterDirection = slideDirection === LEFT ? -1 : 1;
  var leaveDirection = enterDirection * (unidirectional ? -1 : 1);
  var transitions = reactSpring.useTransition(items, function (i) {
    return i && i.key;
  }, {
    config: {
      duration: 200,
      mass: 1,
      tension: 500,
      friction: 1,
      clamp: true
    },
    initial: {
      transform: "translate3d(0%, 0, 0)"
    },
    from: {
      transform: "translate3d(".concat(100 * enterDirection, "%, 0, 0)"),
      position: 'absolute'
    },
    enter: {
      transform: "translate3d(0%, 0, 0)"
    },
    leave: {
      transform: "translate3d(".concat(100 * leaveDirection, "%, 0, 0)"),
      position: 'absolute'
    }
  });
  var AnimatedComponent = reactSpring.animated[transitionComponent];
  return /*#__PURE__*/React.createElement(Container, null, transitions.map(function (_ref2) {
    var item = _ref2.item,
      props = _ref2.props,
      key = _ref2.key;
    return item && /*#__PURE__*/React.createElement(AnimatedComponent, {
      key: key,
      style: props
    }, item);
  }));
};
List.defaultProps = {
  slideDirection: LEFT,
  containerComponent: styled.div.withConfig({
    componentId: "sc-1b9dzm1-0"
  })(["overflow-x:hidden;"]),
  transitionComponent: 'div',
  unidirectional: true,
  item: {}
};
List.propTypes = {
  slideDirection: PropTypes.oneOf([LEFT, RIGHT]),
  unidirectional: PropTypes.bool,
  containerComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.func]),
  transitionComponent: PropTypes.node,
  item: PropTypes.shape({
    wrapper: PropTypes.func,
    divider: PropTypes.func
  }),
  children: PropTypes.node.isRequired
};

exports.LEFT = LEFT;
exports.RIGHT = RIGHT;
exports.default = List;
